import { Pipe, PipeTransform } from '@angular/core';
import { CONSTANTS } from '../../../../shared/constants/constants';

@Pipe({
  name: 'eventImage',
})
export class EventImagePipe implements PipeTransform {
  readonly CONSTANTS = CONSTANTS;
  transform(eventCode: string, eventType: string): string {
    const lockedEvent = CONSTANTS.LOCK_ICON;
    const unlockIconEvent = CONSTANTS.UNLOCK_ICON;
    const onlineEvent = CONSTANTS.ONLINE_DEVICE_EVENT_CODE;
    const alertEvent = CONSTANTS.ALERT_DEVICE_EVENT_CODE;
    const unlockEvent = CONSTANTS.UNLOCK_DEVICE_EVENT_CODE;
    const unKnownEvent = CONSTANTS.UNKNOW_EVENT_UNIT_CODE;
    const lockedUnitEvent = CONSTANTS.LOCKED_UNIT_EVENT_CODE;

    switch (true) {
      case lockedEvent.includes(eventType):
        return CONSTANTS.LOCK;
      case unlockIconEvent.includes(eventType):
        return CONSTANTS.UNLOCK_EVENT_ICON;
      case onlineEvent.includes(eventCode):
        return CONSTANTS.ONLINE_ICON;
      case alertEvent.includes(eventCode):
        return CONSTANTS.ALERT_ICON;
      case unlockEvent.includes(eventCode):
        return CONSTANTS.UNLOCK_EVENT_ICON;
      case unKnownEvent.includes(eventCode):
        return CONSTANTS.UNKNOWN_ICON;
      case unlockEvent.includes(eventCode):
        return CONSTANTS.UNLOCK_EVENT_ICON;
      case lockedUnitEvent.includes(eventCode):
        return CONSTANTS.LOCK_ICON;
      default:
        return CONSTANTS.LOCK_ICON;
    }
  }
}
